import axios from 'axios';

import { SLACK_MESSAGE_TYPES, SLACK_CHANNELS } from './slack.constants';

const VUE_APP_FIREBASE_CLOUD_FUNCTIONS = getEnvironmentCloudFunctionsUrl();

function getEnvironmentCloudFunctionsUrl() {
    /*eslint-disable */
    var functionsUrl;
    switch(window.environment) {
        case "Development":
        case "Integration":
            functionsUrl = 'https://us-central1-is-keap-web-intg.cloudfunctions.net/app';
            break;
        case "Staging":
        case "Proofing":
            functionsUrl = 'https://us-central1-is-keap-web-stge.cloudfunctions.net/app';
            break;
        case "Production":
        default:
            functionsUrl = 'https://us-central1-is-flagship-web-prod.cloudfunctions.net/app';
            break;
    }

    return functionsUrl;
};

const sendFeedback = async (slackChannel, {
    pretext,
    messageType = SLACK_MESSAGE_TYPES.SUCCESS,
    text,
}) => {
    const isTestAccount = window.username && window.username.includes('@keap-automation.m8r.co');
    const payload = {
        slack_channel: isTestAccount ? SLACK_CHANNELS.SELENIUM_AUTOMATION_FEEDBACK : slackChannel,
        attachments: [
            {
                color: messageType,
                pretext,
                author_name: window.fullName,
                title: window.username,
                title_link: `mailto:${window.username}`,
                text,
                footer: `infusionsoft-core environment: ${window.environment}`,
            },
        ],
    };

    await axios.post(`${VUE_APP_FIREBASE_CLOUD_FUNCTIONS}/slack`, payload);
};

export default {
    sendFeedback,
};
